import { ConfigStore } from "../../store/modules/config";
import { PersonStore } from "../../store/modules/person";
import { Watch } from "vue-property-decorator";
import { getModule } from "vuex-module-decorators";
import i18n from "@/i18n";
import { OperationVue } from "../operations/OperationVue";
import IOperationService from "../../services/operations/IOperationService";
import { container } from "@/inversify.config";
import { DiTokens } from "../../services/diTokens";
import { SbpDefaultModel } from "../../models/settings/sbpDefaultModel";
import IAlertService from "../../services/alert/IAlertService";

export class SbpDefaultModalVue extends OperationVue {
  get alertService(): IAlertService {
    return container.get<IAlertService>(DiTokens.AlertService);
  }

  @Watch("tryCount", { immediate: true })
  changed(count: number) {
    if (count < 1) {
      this.alertService.clear();
      this.alertService.sbp(
        i18n.t("main.settings.errors.codeTryCount").toString()
      );
      this.$emit("hideSelf");
    }
  }

  get tryCount() {
    return this.OperationModel.TryCount;
  }

  /** Стор профиля */
  get configStore(): ConfigStore {
    return getModule(ConfigStore, this.$store);
  }

  get personStore(): PersonStore {
    return getModule(PersonStore, this.$store);
  }

  get getSbpTimerLifeTime(): number {
    if (!isNaN(this.configStore.apiData.SbpVerificationCodeLifeTime / 60)) {
      return this.configStore.apiData.SbpVerificationCodeLifeTime / 60;
    }
    return 3;
  }

  /**Инициализация операции */
  async initOperation(): Promise<void> {
    this.loading = true;
    this.service = container.get<IOperationService>(DiTokens.SbpDefaultService);
    this.OperationModel = (await this.service.init(
      this.configStore,
      this.personStore
    )) as SbpDefaultModel;
    this.loading = false;
  }
}
